import { useEffect, useRef, useState } from 'react';
import EditComponent from './FaPiaoTypeEdit';
import WebUniversal, { WUExtendPropsType } from '../system/WebUniversalNewEx'
import { columnsheadId } from '../universal/columnshead';
import { Button, Space } from 'antd';

const WebComponent = (props: any) => {
    const ref = useRef<any>(undefined);
    const [membershipTypeId, setMembershipTypeId] = useState<any>();
    const [modalVisibleMembershipApplicablesShops, setModalVisibleMembershipApplicablesShops] = useState<any>();
    /** 后端数据defaultService */
    let defaultService: any = '';

    useEffect(() => {
        if (ref.current) {
            // eslint-disable-next-line react-hooks/exhaustive-deps
            defaultService = ref.current.defaultService;
        }
        //同步获取数据 async - await
        // const fetchData = async () => {
        // }
        // fetchData();
        //禁用规则
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); //初始化数据

    //表头
    const columnsHead = [
        {
            title: '名称',
            dataIndex: 'typeName',
        },
        {
            title: '默认',
            dataIndex: 'isDefault',
            render: (val: boolean) => val === true ? '是' : '否'
        },
    ];

    const columns = columnsheadId
        .concat(columnsHead as []);

    let extendProps: WUExtendPropsType = {
        ...props,
        titleName: '发票类型',
        apiId: 'faPiaoType',
        columns,
        showStates: true,
        EditComponent,
        serviceId: 'business'
    };

    return (
        <>
            <WebUniversal props={extendProps} ref={ref} />
        </>
    )
}

export default WebComponent;
